import { formatStatusLabel, getProjectStatusClass } from '../../utils/formatStatusLabel';
import './ProjectStatusBadge.css';

const ProjectStatusBadge = ({ status, className = '', style, as: Tag = 'span' }) => {
  const classes = [
    'project-status-badge',
    getProjectStatusClass(status),
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} style={style}>
      {formatStatusLabel(status)}
    </Tag>
  );
};

export default ProjectStatusBadge;
